import React from 'react';
import styles from './index.module.scss';
import castrol from '../../../../images/castrol-logo.svg';
import fordWhite from '../../../../images/ford-logo-white.svg';
import fordDark from '../../../../images/ford-logo.svg';

interface IProps {
  isDark?: boolean;
}

const FordBrand = (props: IProps) => {
  const { isDark = false } = props;
  return (
    <div className={styles.container}>
      <img src={castrol}/>
      <span className={!isDark ? styles.white : undefined}> | </span>
      <img src={isDark ? fordDark : fordWhite }/>
    </div>
  )
}

export default FordBrand;
